const expressionLanguage = {
    mobile: /^1[0-9]{10}$/,
    validCode: /^[0-9]{4}$/,
    bankSmsCode: /^[0-9]{1,10}$/,
    recommendation: /^(\d{5}|\d{7})$/,
    password: /^[0-9]{6}$/,
    chineseWord: /^[\u4e00-\u9fa5]+$/,
    bankCard: /^(\d{11}|\d{16,19})$/,
    postCode: /^[0-9]{6}$/,
    idCardNo: /^\d{17}([0-9]|X)$/,
    shaNo: /^A[0-9]{9}$/,
    szaNo: /^(00|01|02)[0-9]{8}$/
}

export function getUrlParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, '\\$&');
	let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



export function showTips(tipsCont,tipsTimeout){
    tipsCont? this.tipsCont=tipsCont:this.tipsCont="";
    tipsTimeout? this.tipsTimeout=tipsTimeout:this.tipsTimeout=1000;
    let _this = document.createElement("DIV");
    let tips='<span style="background:#4c4c4c;color:#fff;border-radius:20px;padding:10px 20px;">'+this.tipsCont+'</span>';
    _this.setAttribute("style","position:fixed;top:50%;margin-top:-20px;z-index:9999;left:0;text-align:center;width:100%;opicaty:1");
    _this.innerHTML=tips;
    document.getElementsByTagName('body')[0].appendChild(_this);
    setTimeout(function(){
        _this.remove()
    },this.tipsTimeout);
}


export function isMobileNumber(mobile) {
    return expressionLanguage.mobile.test(mobile)
}

export function isPicCode(code) {
    return expressionLanguage.validCode.test(code)
}

export function isSmsCode(code) {
    return expressionLanguage.postCode.test(code)
}

export function getPercent(number) {
    return Number.parseFloat((parseFloat(number)*100).toFixed(2))
}



// WEBPACK FOOTER //
// ./src/common/js/common-util.js